// extracted by mini-css-extract-plugin
module.exports = {"title":"FooterSocial_title__kBfns","icons":"FooterSocial_icons__2NmFC","icon":"FooterSocial_icon__17-Xd","svg":"FooterSocial_svg__1t4tk"};